import { AccessReason } from '@/types/enum';
import i18n from '@/i18n';

export const getReasons = (accessReason: string, client: string, daysOfTransactions: number) => {
    switch (accessReason.toLowerCase()) {
        case AccessReason.Credit:
            return [
                'Carry out an affordability and credit assessment',
                'Verify your income',
                'Help to make a responsible lending decision',
            ];
        case AccessReason.Broker:
            return [
                'Verify your income',
                'To assess your eligibility for lending products',
                'Carry out an affordability and credit assessment',
                'Help to make a responsible lending decision',
            ];
        case AccessReason.BrokerFF:
            return [
                'Verify who you are',
                'Match you with better suited products',
                'Show you how you appear to lenders',
            ];
        case AccessReason.PersonalFinanceManagerJC:
            return [
                'Assess and monitor your financial performance',
            ];
        case AccessReason.CreditVodafone:
            return [
                'Carry out an assessment of our lending criteria to assist with future lending decisions',
            ];
        case AccessReason.CreditNext:
            return [
                'Carry out an affordability assessment',
                'Provide you with a suitable payment plan'
            ];
        case AccessReason.CreditSTB:
            return [
                'Assessing the risk of granting credit',
                'Monitoring and verifying incomings and outgoings in relation to Asset based lending facilities'
            ];
        case AccessReason.CreditOptimum:
            return [
                'To help make ongoing responsible lending decisions',
                'To maintain a transparent relationship between the Optimum Finance team and you'
            ];
        case AccessReason.CreditAccountManagement:
            return [
                'Assist in monitoring your financial circumstances',
                'Provide you with a suitable payment plan',
                'Help decide on your repayment terms',
            ];
        case AccessReason.Identity:
            return ['Verify your Bank Account Information and ID'];
        case AccessReason.Comparison:
            return [
                'Help determine which offers are best suited to your individual needs',
                'Provide you with customised product comparison offers',
            ];
        case AccessReason.PersonalFinanceManager:
            return ['Assist in monitoring your financial circumstances'];
        case AccessReason.DebtManagement:
            return [
                'Provide you with a suitable payment plan',
                'Help decide on your repayment terms',
                'Provide you with debt advice and debt management services',
                'Help you in establishing debt management plans and administering debt management plans',
            ];
        case AccessReason.Collections:
            return [
                'Estimate your income and expenditure',
                'Undertake affordability assessments'
            ];
        case AccessReason.TenantReference:
            return ['Verify your income and rental payment history'];
        case AccessReason.DebtAdvice:
            return [
                'Enable ' + client + ' to pre-complete your income and expenditure',
                'Save time on your review call',
                'More accurate data will help ensure we provide you with suitable advice',
            ];
        case AccessReason.DebtAdviceFJ:
            return [
                'Enable ' +
                client +
                ' to complete your income and expenditure and confirm your income',
                'Avoid having to find old paperwork',
                'No need to send ' + client + '  evidence or payslips',
                'Helping ' + client + '  to help you finish your IVA on time',
            ];
        case AccessReason.DebtAdviceMP:
            return [
                'Provide you with a suitable debt solution',
                'Help determine an affordable payment',
                'Provide you with debt advice and debt solution services',
                'Help you in establishing and administering a Debt Management Plan, Individual Voluntary Arrangement or Protected Trust Deed',
            ];
        case AccessReason.TrustDeed:
            return ['Help determine the information needed to prepare a Trust Deed on your behalf'];
        case AccessReason.ValueAlignedSpending:
            return [
                'To calculate how much of your spending is with businesses that align with your values',
                'To give you recommendations for businesses that align with your values'
            ];
        case AccessReason.LoanReview:
            return ['Review your loan payment affordability for the last ' + getTransactionTimeFrame(daysOfTransactions)];
        case AccessReason.VerifyIncomeVanquis:
            return [
                'Use 3 months of the transactions data collected to verify your income',
                'Collect 12 months of transaction data for analytical purposes to improve our products and services'
            ];
        case AccessReason.VerifyIncome:
            return [
                'To assess your monthly income and expenditure',
                'Verify your source of funds'
            ];
        case AccessReason.StandardVerifyIncome:
            return [
                'To assess your monthly income',
                'Verify your source of funds'
            ]
        case AccessReason.CreditFintern:
            return [
                'Carry out an affordability and credit assessment',
                'Verify your income and account balances',
                'Help to make a responsible lending decision',
                'Proactively monitor and manage credit risk',
                'Allow you to test different affordable payment amounts, and view the associated borrowing cost & time to repay'
            ];
        case AccessReason.StandardBroker:
            return [
                'Match you with better suited products',
                'Validate your income & identity',
                'Carry out an affordability and credit assessment'
            ];
        case AccessReason.StandardForbearance:
            return [
                'Monitor your current financial circumstances',
                'Assess whether ' + client + ' can provide forbearance measures'
            ];
        case AccessReason.BasicCredit:
            return [
                'Checking you can afford the loan',
                'Verifying your income',
                'Help make a responsible lending decision'
            ];
        case AccessReason.CreditSME:
            return [
                'Carry out an affordability and credit assessment',
                'Help to verify your company financial position',
                'Help to make a responsible lending decision'
            ];
        case AccessReason.CreditSMEID:
            return [
                'Verify your Bank Account Information and ID',
                'Carry out an affordability and credit assessment',
                'Help to verify your company financial position',
                'Help to make a responsible lending decision'
            ];
        case AccessReason.ServiceAccess:
            return [
                'Carry out an affordability assessment',
                'Verify your income',
                'Help make a responsible access to service decision'
            ];
        case AccessReason.CreditID:
            return [
                'Verify your Bank Account Information and ID',
                'Carry out an affordability and credit assessment',
                'Verify your income',
                'Help to make a responsible lending decision'
            ];
        case AccessReason.CreditLL:
            return [
                'Perform Credit & Affordability Assessments',
                'Help personalise your repayments',
                'Assessing suitability for lending products'
            ];
        case AccessReason.CreditPlus:
            return [
                'Carry out an affordability and credit assessment',
                'Verify your income, expenditure or bank details',
                'Help to make a responsible lending decision'
            ];
        case AccessReason.GrantAssessment:
            return [
                'Assess your income and expenditure to establish what level of grant you could be eligible for',
                'Increase the speed of our assessment and payment of grants'
            ];
        case AccessReason.VerifyIncomeStandard:
            return [
                'Verify your income',
                'Help to make a responsible lending decision'
            ];
        case AccessReason.IDInternational:
            return [
                'Verify your Bank Account Information and ID',
                'Help to verify your company financial position',
                'Help to verify your international relationships',
                'Help to make a decision for opening a new business account'
            ];
        case AccessReason.IncomeAffordability:
            return [
                'Verify Your Income',
                'Carry out an affordability and credit assessment'
            ];
        case AccessReason.VerifyIncomeAnalytics:
            return [
                'Verify your income',
                'Help to make a responsible lending decision',
                'For analytical purposes'
            ];
        case AccessReason.BrokerToken:
            return [
                'Verify who you are',
                'Show you how you appear to lenders',
                'Share a token with lenders named in our Privacy Policy to make a lending assessment',
                'Determine which lenders to refer you to for a lending assessment',
            ];
        case AccessReason.BrokerTokenFF:
            return [
                'Verify who you are',
                'Show you how you appear to lenders',
                'Determine which lenders to refer you to for a lending assessment',
                'Share your account and transaction details with the following panel of lenders via Freedom Finance: <ul><li>Oakbrook Finance Limited trading as Likely Loans</li><li>Amplifi Capital (UK) Ltd trading as My Community Finance</li><li>Koyo Loans</li></ul>',
            ];
        case AccessReason.ResearchDevelopment:
            return [
                'Research, analyse and understand the potential for more personalised and relevant membership features and benefits'
            ];
        case AccessReason.GrantCriteria:
            return [
                'Assess your income and expenditure to establish if you meet the financial criteria for a grant',
                'Increase the speed of our assessment and payment of grants'
            ];
        case AccessReason.VerifyAndDispatch:
            return [
                'Verify your Bank Account information to dispatch your order'
            ];
        case AccessReason.VerifyIncomePivotal:
            return [
                'Carry out an affordability and credit assessment and;',
                'Verify your income'
            ];
        case AccessReason.IncomeAffordabilityUU:
            return [
                'Estimate income',
                'Undertake affordability assessments'
            ];
        case AccessReason.TenantRefAffordability:
            return [
                'Carry out an affordability and credit assessment',
                'Verify your income and rental payment history'
            ];
        case AccessReason.TenantAffordability:
            return [
                'Provide affordability information to letting agents and landlords about a prospective tenant',
                'This includes identification of monthly income, committed outgoings and previous rental payments'
            ];
        case AccessReason.VerifyBank:
            return [
                'Verify your Bank Account Information'
            ];
        case AccessReason.CreditRiskMasthaven:
            return [
                'Proactively monitor and manage credit risk',
                'To help make ongoing responsible lending decisions'
            ];
        case AccessReason.AffordabilityMortgageable:
            return [
                'Carry out an affordability and credit assessment',
                'Verify your income',
                'Help to make a responsible lending decision',
                'Share your account and transaction details with Evolution Money via Mortgageable'
            ];
        case AccessReason.OBID_FHI:
            return [
                'Verify your Bank Account Information and ID',
                'Provide you with a score that gives insight into your financial health',
                'Equifax will also perform an ID check on your credit data as part of this application. Any information on the nature of this check can be found here <a href="https://www.equifax.co.uk/crain">Credit Reference Agency Information Notice (CRAIN) | Equifax UK</a>'

            ];
        case AccessReason.CarbonFootprint:
            return [
                'Calculate your carbon footprint based on your spending',
                'Recommend behaviours to help you reduce your footprint'
            ];
        case AccessReason.DebtAdviceT:
            return [
                'Provide you with advice, including debt advice services'
            ];
        case AccessReason.BrokerFF2022:
            return [
                'Share your information with lenders expressly instructed by you to receive such information, who may use it to build a better picture of your finances and your affordability in relation to products and services you have requested or enquired about'
            ];
        case AccessReason.CreditCBS:
            return [
                'Verify your income',
                'Carry out an affordability assessment',
                'Help to make a responsible lending decision'
            ];
        case AccessReason.CreditHandelsbanken:
            return [
                'Progress an account opening application, and/or',
                'Carry out an affordability and credit assessment, and/or',
                'Help to make a responsible lending decision'
            ];
        case AccessReason.TransactionVulnerabilityIndicators:
            return [
                'Carry out an affordability and credit assessment',
                'Verify your income',
                'Help to make a responsible lending decision',
                'To identify and assist with potential financial vulnerability'
            ];
        case AccessReason.ApplyPlus:
            return [
                'ApplyPlus'
            ];
        case AccessReason.CreditBT:
            return [
                'Carry out an affordability and credit assessment',
                'Verify your income',
                'Help to make a responsible lending decision',
                'Help decide on your repayment terms'
            ];
        case AccessReason.HastingsInsurance:
            return [
                'Verify your income, expenditure or bank details',
                'Verify the information you have provided'
            ];
        case AccessReason.BinqBroker:
            return [
                'Verify your income',
                'To assess your eligibility for lending products',
                'Carry out an affordability and credit assessment',
                'Help to make a responsible lending decision',
                'To share your information with named third parties or make referrals'
            ];
        case AccessReason.MyEquifaxIDV:
            return [
                'Verify your Bank Account Information and ID',
                'Assist in monitoring your financial circumstances'
            ];
        case AccessReason.MyEquifax:
            return [
                'Assist in monitoring your financial circumstances via myEquifax Finance Monitor',
                'As part of your initial account setup (if applicable), to verify your bank account information and ID'
            ];
        case AccessReason.MonyBroker:
            return [
                'Check your eligibility and provide a quote for financial products, which may include sharing data with our panel of lenders'
            ];
    default:
      return [];
  }
};

export const getTransactionTimeFrame = (daysOfTransactions: number) => {
  let isEs = i18n.locale === 'es-ES';
  if (daysOfTransactions === 365) {
    return isEs ? 'año' : 'year';
  } else if (daysOfTransactions === 730) {
    return isEs ? '2 años' : '2 years';
  } else if (daysOfTransactions === 1095) {
    return isEs ? '3 años' : '3 years';
  } else if (daysOfTransactions === 123) {
    return isEs ? '4 meses' : '4 months';
  } else if (daysOfTransactions === 180 || daysOfTransactions === 182 || daysOfTransactions === 183) {
    return isEs ? '6 meses' : '6 months';
  } else if (daysOfTransactions === 214) {
    return isEs ? '7 meses' : '7 months';
  } else if (daysOfTransactions === 396) {
    return isEs ? '13 meses' : '13 months';
  } else if (daysOfTransactions >= 456 && daysOfTransactions <= 459) {
    return isEs ? '15 meses' : '15 months';
  } else if (daysOfTransactions >= 547 && daysOfTransactions <= 550) {
    return isEs ? '18 meses' : '18 months';
  }
  return daysOfTransactions + (isEs ? ' días' : ' days');
};

export const getPeriod = (accessFrequency: string) => {
  switch (accessFrequency.toLowerCase()) {
    case 'unlimited': {
      return 'There is no access end date.';
    }
    default:
      return '';
  }
}

export const getFrequency = (accessFrequency: string) => {
  let oneoff = i18n.tc('consent.frequencies.oneoff');
  let unlimited = i18n.tc('consent.frequencies.unlimited');
  let onceaweek = i18n.tc('consent.frequencies.onceaweek');
  let onceamonth = i18n.tc('consent.frequencies.onceamonth');
  switch (accessFrequency.toLowerCase()) {
    case 'oneoff':
      return oneoff;
    case 'unlimited': {
      return unlimited;
    }
    case 'onceaweek': {
      return onceaweek;
    }
    case 'onceamonth': {
      return onceamonth;
    }
    default:
      return accessFrequency;
  }
}

export const getTransactions = (accessDataType: string, daysOfTransactions: number) => {
  let incoming = i18n.tc('consent.accountTransactions.incoming');
  let outgoing = i18n.tc('consent.accountTransactions.outgoing');
  switch (accessDataType) {
    case 'AccountBalanceBankTransactionsCredits':
    case 'AccountBalanceBankTransactionsCreditsParty': {
      return [
        incoming + getTransactionTimeFrame(daysOfTransactions),
      ];
    }
    case 'AccountBalanceBankTransactions':
    case 'AccountBalanceBankTransactionsParty': {
      return [
        incoming + getTransactionTimeFrame(daysOfTransactions),
        outgoing + getTransactionTimeFrame(daysOfTransactions),
      ];
    }
    default:
      return [];
  }
}

export const getAccountDetails = (accessDataType: string) => {
  let account = i18n.tc('consent.accountDetails.account');
  let balance = i18n.tc('consent.accountDetails.balance');
  switch (accessDataType) {
    case 'Accounts':
    case 'AccountBeta': {
      return [account];
    }
    case 'AccountBalanceBankTransactions':
    case 'AccountBalanceBankTransactionsCredits': {
      return [account, balance];
    }
    default:
      return [];
  }
}


export const getTrueLayerAccountDetails = (accessDataType: string) => {
  let name = i18n.tc('consentTrueLayer.accountDetails.name');
  let accounts = i18n.tc('consentTrueLayer.accountDetails.accounts');
  let balance = i18n.tc('consentTrueLayer.accountDetails.balance');
  let transactions = i18n.tc('consentTrueLayer.accountDetails.transactions');
  switch (accessDataType) {
    case 'Accounts':
    case 'AccountBeta': {
      return [name, accounts]
    }
    case 'AccountBalanceBankTransactions':
    case 'AccountBalanceBankTransactionsCredits': {
      return [name, accounts, balance, transactions]
    }
    default:
      return [];
  }
}


export const getParties = (accessDataType: string) => {
  let account = i18n.tc('consent.accountParty.account');
  let balance = i18n.tc('consent.accountParty.balance');
  let email = i18n.tc('consent.accountParty.email');
  switch (accessDataType) {
    case 'AccountParty': {
      return [account, email];
    }
    case 'AccountBalanceParty':
    case 'AccountBalanceBankTransactionsParty':
    case 'AccountBalanceBankTransactionsCreditsParty': {
      return [account, balance, email];
    }
    default:
      return [];
  }
}

export const getBeta = (accessDataType: string) => {
  switch (accessDataType) {
    case 'AccountBeta': {
      return ['Payee agreements you have set up', 'Your statements', 'Your standing orders', 'Your direct debits', 'Your recurring and future dated payments'];
    }
    default:
      return [];
  }
}
